import * as EJS from 'ejs';
import * as fs from 'fs';
import {Log, logErr, LogLn, Util} from './Util';
import * as jsbeautify from 'js-beautify';
import * as fse from 'fs-extra';
import {AppJson, View, AppConfig, AppManifest, ComponentId} from './types/App';
import {
  CtrlButtonTypeGui,
  MgControlType,
  SideType,
  StorageAttributeType,
  TableWebStyle,
  WindowType,
  WindowPosition
} from './types/enums/Enums';

import * as _ from 'lodash';

import {TemplateConfig} from "./types/TemplateConfig";
import {prettierConfig, sourceAngularTemplateRootForCli} from './config';

import * as prettier from "prettier";
import {GeneratedFileTypes} from './types/enums/GeneratedFileTypes';
import {processJson} from './ProcessJson';
import {FileAPI} from './FileAPI';

const htmlBeautify = jsbeautify.html;
const cssBeautify = jsbeautify.css;

// @dynamic
export class MgCliFactory {
  static app: AppJson;
  static magic_config: AppConfig;
  static manifest: AppManifest;

  ////////////////////////////////////////////////
  // input point for generating a single form, for the mg-cli
  ////////////////////////////////////////////////
  static buildComponent(inputFile: string, outputRoot: string, theme: string, allow_testing: boolean): void {

    let saveCurrentDirectory =process.cwd();
    //process.chdir('D:\\trunk\\Sources\\Webclient\\projects\\template-factory');
    process.chdir('./node_modules/@magic-xpa/template-factory');

    LogLn( "Rinat ==> " + process.cwd());
    console.log(`********start buildComponent*********`);
    console.log(`* inputFile     => ${inputFile}     *`);
    console.log(`* outputRoot    => ${outputRoot}    *`);
    console.log(`* theme         => ${theme}         *`);
    console.log(`* allow_testing => ${allow_testing} *`);
    console.log(`*************************************`);

    // initialize the config using the parameters
    this.magic_config = {} as AppConfig;
    this.magic_config.theme = theme;
    this.magic_config.output_folder = outputRoot;
    this.magic_config.allow_testing = allow_testing;
    this.magic_config.form_files = [];
    this.magic_config.form_files.push(inputFile);
    this.magic_config.project_name = outputRoot.split('\\').pop();

    // initialize defaults
    this.magic_config.create_new_project = false;
    this.magic_config.absolute_position = false;
    this.magic_config.exposed_functionality = true;


    // read the view (= form) json file
    // LogLn("1. readInputJson");
    this.app = FileAPI.readInputJson(this.magic_config);

    // initialize the output directory
    FileAPI.destDir = this.magic_config.output_folder;

    // LogLn(' FileAPI.destDir ==> ' +  FileAPI.destDir);

    // process the view object, get the classes used for each control
    // LogLn("2.    start prepare classes...");
    this.app = processJson(this.app);

     // create an updated manifest
    // LogLn("start prepareManifest...");
    this.manifest = this.prepareManifest();

    // build the files for each and every view
    // LogLn("3.   start buildView...");
    this.buildView(this.magic_config.output_folder + '\\');

    // LogLn("4.   start buildComponentList...");
    this.buildComponentList(this.magic_config.output_folder + '\\');

    // console.log(`********end buildComponent*********`);

    process.chdir(saveCurrentDirectory);
  };

  ////////////////////////////////////////////////
  // build the files for all views
  ////////////////////////////////////////////////
  static buildView(outputDir: string): void {

    // LogLn("3.1.   In buildView");
    // LogLn("current directory ====>>>>> " + process.cwd());

    const
      viewId = this.app.views[0].props.id,
      dest                             = outputDir + `/src/app/` + this.app.views[0].props.component_path,

      data = {
        MgControlType: MgControlType,
        theme: this.magic_config.theme,
        CtrlButtonTypeGui: CtrlButtonTypeGui,
        SideType: SideType,
        StorageAttributeType: StorageAttributeType,
        TableWebStyle: TableWebStyle,
        WindowType: WindowType,
        WindowPosition: WindowPosition,
        Util: Util,
        ctrl: this.app.views[0],
        app: this.app,
        _: _,
        magicConfig: this.magic_config,
      },

      // templates for creating different output files
      componentFiles: TemplateConfig[] = [
        {
          type: GeneratedFileTypes.TS,
          template: './src/lib/templates/component/view.component.ts',
          destination: dest,
          name: `${viewId}.component.ts`,
          data: data
        },
        {
          type: GeneratedFileTypes.HTML,
          template: './src/lib/templates/component/view.component.html',
          destination: dest,
          name: `${viewId}.component.html`,
          data: data
        },

        // {
        //   type       : GeneratedFileTypes.CSS,
        //   destination: dest,
        //   template   : './src/lib/templates/component/view.component.css',
        //   name       : `${viewId}.component.css`,
        //   data       : data
        // }
      ]

    // LogLn("3.2.   start componentFiles.forEach");
    componentFiles.forEach(templateConfig => this.generate(templateConfig))
    // LogLn("3.3.   end componentFiles.forEach");
  };

  ////////////////////////////////////////////////
  // build the component list
  ////////////////////////////////////////////////
  static buildComponentList(outputDir: string) {

    const
      appId     = this.app.name,
      appRoot   = this.magic_config.output_folder + `\\${appId}`,
      data: any = {
        app: this.app,
        manifest: this.manifest,
      };

    const componentFile: TemplateConfig = {
      template: `${sourceAngularTemplateRootForCli}/app/component-list.g.ts`,
      name: 'component-list.g.ts',
      destination: outputDir + `/src/app/`,
      type       : GeneratedFileTypes.TS,
      data       : data

    };

    this.generate(componentFile);
  }


  ////////////////////////////////////////////////
  // generate file using the specified template
  ////////////////////////////////////////////////
  static generate(file: TemplateConfig) {
    Log(`>> generating file ${file.name}...\t\t`);
    EJS.renderFile(file.template, file.data, {}, (err, output) => {
      if (err)
      {
        logErr(err);
      }

      const
        fnMap = {
          [GeneratedFileTypes.HTML]: htmlBeautify.bind(this, output, {
            "max_preserve_newlines": 0,
            "wrap_line_length"     : 0,
            "wrap_attributes"      : "force-expand-multiline"
          }),
          [GeneratedFileTypes.TS]  : prettier.format.bind(this, output, prettierConfig),
          [GeneratedFileTypes.CSS] : cssBeautify.bind(this, output, {})
        };

      try
      {
        output = fnMap[file.type]();

      }
      catch (err)
      {

        logErr(output);
        logErr(err);

      }

      fse.ensureDirSync(file.destination);
      fs.writeFileSync(`${file.destination}/${file.name}`, output);
      LogLn('[success]');
    });

  }

  /////////////////////////////////////////////////////
  // prepare the manifest with the new generation info
  /////////////////////////////////////////////////////
  static prepareManifest(): AppManifest {
    let manifest: AppManifest = FileAPI.getOldManifest(this.magic_config, this.app.name);
    this.AddViewsToManifest(manifest);
    FileAPI.WriteManifest(manifest, this.app.name);

    return manifest;
  }

  ////////////////////////////////////////////////
  // add the current views to the new manifest
  ////////////////////////////////////////////////
  static AddViewsToManifest(manifest: AppManifest): void {
    this.app.views.forEach((view: View) => {
      let compid: ComponentId = {path: '', name: '', uniqueName: ''};
      compid.path = view.props.component_path;
      compid.name = view.props.id;
      compid.uniqueName = view.props.component_uniquename;

      if (manifest.components.findIndex(x => x.name === compid.name && x.path == compid.path) < 0)
      {
        manifest.components.push(compid);
      }
    });

    console.log("Adding components to manifest" );
  }
}











